// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import echarts from 'echarts'
// import 'element-ui/lib/theme-chalk/index.css'
// import './assets/theme/index.css'
import './element-variables.scss'
import promise from 'es6-promise'
import axios from 'axios'
import store from './store'
promise.polyfill()
if (process.env.NODE_ENV === 'production') {
  const BaseURL = JSON.parse(localStorage.getItem('BaseURL'))
  if (BaseURL && BaseURL.ApiUrl) {
    axios.defaults.baseURL = BaseURL.ApiUrl
    store.state.reportBaseUrl = BaseURL.ReportUrl || BaseURL.ApiUrl
  } else {
    axios.get('serverconfig.json').then(result => {
      localStorage.setItem('BaseURL', JSON.stringify(result.data))
      axios.defaults.baseURL = result.data.ApiUrl
      store.state.reportBaseUrl = result.data.ReportUrl || result.data.ApiUrl
    }).catch((error) => { console.log(error) })
  }
} else {
  store.state.reportBaseUrl = 'http://192.168.10.24:29298/'
}

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js